import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CarouselModule } from 'ngx-bootstrap/carousel';

import { MainRoutingModule } from './main-routing.module';
import { MainComponent } from './main.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { CtaModule } from '../../shared/cta/cta.module';
import { FormsModule, NgForm, ReactiveFormsModule } from '@angular/forms';
import { NgxCaptchaModule } from 'ngx-captcha';

@NgModule({
  declarations: [MainComponent],
  imports: [
    CommonModule,
    CarouselModule.forRoot(),
    MainRoutingModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    NgxCaptchaModule,
    CtaModule,
  ],
  providers: [
    NgForm
  ]
})
export class MainModule {}
